import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

/**
 * Rendered instead of a protected module's content once
 * entitlement_status === "expired" (App.js gate). Billing/Account/Logout
 * remain reachable via the sidebar — only the module content area swaps.
 */
export default function TrialExpiredBlock() {
  const navigate = useNavigate();
  return (
    <div data-testid="trial-expired-block" className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-50">
          <ShieldAlert className="h-6 w-6 text-amber-600" />
        </div>
        <h2 className="mt-4 text-[17px] font-bold text-[#1E3A5F]">Your trial has ended</h2>
        <p className="mt-2 text-[13px] text-slate-500">
          Choose a C-ORE plan to keep using this module. Your data is safe and will be here
          the moment you upgrade.
        </p>
        <button
          data-testid="trial-expired-upgrade-btn"
          onClick={() => navigate("/pricing")}
          className="mt-5 inline-flex min-h-[44px] items-center justify-center rounded-lg bg-[#1E3A5F] px-5 text-[13px] font-semibold text-white hover:opacity-90"
        >
          View plans &amp; upgrade
        </button>
      </div>
    </div>
  );
}
